import styled from 'styled-components';

const StyledTextContainer = styled.div`
	position: relative;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	font-family: 'GT Walsheim Pro';
	font-size: 14px;
	font-weight: 500;
	color: #e6e6e6;

	span:first-child {
		user-select: none;
	}
`;

export { StyledTextContainer };
